module.exports = __webpack_public_path__ + "img/grade3.f2094f7d.png";